console.log('**** MAIN ****')
import { createApp } from 'vue'
import { Buffer } from 'node:buffer'
import Vue3Toastify from 'vue3-toastify'
import { createHead, VueHeadMixin } from '@unhead/vue/client'

import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue'

import { createPinia } from 'pinia'
import App from './App.vue'
import dayjs from '@/plugins/dayjs'
import i18n from '@/i18n/i18n-setup.js'
import vuetify from '@/plugins/vuetify.js'
import router from './router'
import { registerServiceWorker } from '@/registerServiceWorker.js'

import '@/assets/css/main.css'
import '@mdi/font/css/materialdesignicons.css'

import 'vue3-toastify/dist/index.css'
import vue3Spinner from 'vue3-spinner'

window.Buffer = Buffer

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

// import Toast, { TYPE } from 'vue-toastification'
// Import the CSS or use your own!
// import 'vue-toastification/dist/index.css'
/*
const toastOptions = {
  timeout: 4000,
  maxToasts: 3,
  newestOnTop: true,
  showCloseButtonOnHover: true,
  position: 'top-center',
  transition: 'Vue-Toastification__fade',
  [TYPE.ERROR]: {
    timeout: 8000,
    hideProgressBar: true
  }
}
*/
app.config.globalProperties.$date = dayjs

app.mixin(VueHeadMixin)

app.use(head)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)
app.use(vue3Spinner)
// app.use(Toast, toastOptions)
app.use(Vue3Toastify, {
  autoClose: 5000,
  limit: 5
})
app.use(CkeditorPlugin)

app.mount('#app')
registerServiceWorker()
